import ReCAPTCHA from 'react-google-recaptcha';

export const getRecaptchaToken = async (
  recaptchaRef?: React.RefObject<ReCAPTCHA>
): Promise<string | null> => {
  if (!recaptchaRef?.current) {
    return null;
  }

  try {
    return await recaptchaRef.current.executeAsync();
  } catch (error) {
    console.error('Recaptcha execution failed:', error);
    return null;
  }
};

export const appendRecaptchaTokenToUrl = (
  baseUrl: string,
  token: string | null
): string => {
  if (!token) {
    return baseUrl;
  }
  const separator = baseUrl.includes('?') ? '&' : '?';
  return `${baseUrl}${separator}captcha_token=${encodeURIComponent(token)}`;
};
